import styled from 'styled-components';

import { colors } from '../../../core';

export interface SpanProps {
  align?: 'left' | 'center' | 'right';
  size?: 'small' | 'medium';
  weight?: '500' | '600' | '700';
  noMargin?: boolean;
}

const sizeMap = {
  small: '14px',
  medium: '16px',
};

const Span = styled.span<SpanProps>`
  color: ${({ color }) => color || colors.charcoal};
  font-family: ${({ theme }) => theme.fontFamily || `Quicksand, san-serif`};
  font-size: ${({ size }) => sizeMap[size || 'medium']};
  font-weight: ${({ weight }) => weight || 500};
  line-height: 1.5;
  margin: ${({ noMargin }) => (noMargin ? 0 : '0 0 16px')};
  ${({ align }) => align && `text-align: ${align};`}
`;

export default Span;
